import { render, staticRenderFns } from "./PreviewSidebar.vue?vue&type=template&id=05b469f3&"
import script from "./PreviewSidebar.vue?vue&type=script&lang=js&"
export * from "./PreviewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports